// src/components/Toast.jsx
export default function Toast({ toast }) {
  return (
    <div className={`toa-toast${toast.show ? " show" : ""}`}>
      {toast.msg}
    </div>
  );
}
